'use strict';

class DatosAsociacionController {
  constructor() {

  }


}

export default DatosAsociacionController;



// WEBPACK FOOTER //
// ./src/app/components/empresas/c-empresas/datos-asociacion/datos-asociacion.controller.js